module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/auto_bg@1x.png?0.0.53";